import { config } from '../../common/config'
import SiteConfig from '../../config/sites'
import { Consent, deferRun } from './consent'

const loadScript = (src: string) => {
  const scriptTag = document.createElement('script')
  const firstScriptTag = document.getElementsByTagName('script')[0]

  scriptTag.async = true
  scriptTag.src = src
  if (firstScriptTag.parentNode) {
    firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag)
  }
}

export const deferLoadGTMScript = () => {
  deferRun(() => {
    const w = window as any
    w.dataLayer = w.dataLayer || []
    w.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    })

    const containerId = SiteConfig.defaults.google_tag_manager_id
    loadScript(`https://www.googletagmanager.com/gtm.js?id=${containerId}`)
  }, Consent.marketing)
}

export const deferLoadIntercomScript = () => {
  const intercomAppId = config.analytics.intercom.APP_ID

  if (intercomAppId) {
    deferRun(
      () => loadScript(`https://widget.intercom.io/widget/${intercomAppId}`),
      Consent.marketing
    )
  }
}

export const deferLoadGoogleAnalytics = () => {
  deferRun(
    () => loadScript('https://www.google-analytics.com/analytics.js'),
    Consent.statistics
  )
}
